import { NgModule } from '@angular/core';

import { MxDialogModule } from './mx.dialog/mx.dialog.module';
import { MxDropdownModule } from './mx.dropdown/mx.dropdown.module';
import { MxFileUploadModule } from './mx.file-upload/mx.file-upload.module';
import { MxFormControlMessagesModule } from './mx.form-control/mx.form-control-messages/mx.form-control-messages.module';
import { MxInputSwitchModule } from './mx.input-switch/mx.input-switch.module';
import { MxMultiSelectModule } from './mx.multi-select/mx.multi-select.module';
import { MxOverlayPanelModule } from './mx.overlay-panel/mx.overlay-panel.module';
import { MxSliderModule } from './mx.slider/mx.slider.module';
import { MxTableModule } from './mx.table/mx.table.module';
import { MxPostModule } from './mx.post/mx.post.module';

@NgModule({
  exports: [
    MxFormControlMessagesModule,
    MxDialogModule,
    MxTableModule,
    MxSliderModule,
    MxDropdownModule,
    MxMultiSelectModule,
    MxInputSwitchModule,
    MxOverlayPanelModule,
    MxFileUploadModule,
    MxPostModule
  ],
})
export class MxComponentsModule { }
